import { useEffect, useState } from "react";

function ThemeToggle() {
  const [theme, setTheme] = useState("light");

  // Load saved theme on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  // Save and apply theme on change
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <button
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      style={{
        width: "30px",            // fixed width
        height: "30px",           // fixed height
        borderRadius: "50%",      // makes it a circle
        border: "none",
        cursor: "pointer",
        background: "var(--text-muted)", // uses your theme variable
        display: "flex",          // center icon/text
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.3s ease",
        margin: "15px",
        position:"relative",
        right:"2%"
      }}
      
    >
      {theme === "light" ? "🌚" : "🌞"}
    </button>
  );
}

export default ThemeToggle;
